<template>
    <div>
        <Form :model="projectItem" ref="formValidate" :label-width="120" :rules="formValidate">
             <FormItem label="项目名称：" prop="projectName">
                <Input v-model="projectItem.projectName" autocomplete="off" ></Input>
            </FormItem>
             <FormItem label="项目状态：" prop="status">
                 <Select v-model="projectItem.status" >
                    <Option value="合作中">合作中</Option>
                    <Option  value="合作结束">合作结束</Option>
                </Select>
            </FormItem>
                <FormItem label="项目经理：" prop="manager">
                <Input v-model="projectItem.manager" autocomplete="off" ></Input>
            </FormItem>
            <FormItem label="开始时间：" prop="startTime">
                <DatePicker type="date" placeholder="选择日期" v-model="projectItem.startTime"   @on-change="getStartTime"   ></DatePicker>
            </FormItem>
            <FormItem label="结束时间：" prop="endTime">
                <DatePicker type="date" placeholder="选择日期" v-model="projectItem.endTime" @on-change="getEndTime"></DatePicker>
            </FormItem>
            <FormItem label="承包量：" prop="amount">
                <Input v-model="projectItem.amount" autocomplete="off" ></Input>
            </FormItem>
            <FormItem label="效率：" prop="efficiency">
                <Input v-model="projectItem.efficiency" autocomplete="off" ></Input>
            </FormItem>
             <FormItem label="质量：" prop="performance">
                <Input v-model="projectItem.performance" autocomplete="off" ></Input>
            </FormItem>
               <FormItem label="评价：" prop="maluation">
                <Input v-model="projectItem.maluation" autocomplete="off" ></Input>
            </FormItem>
        </Form>
    </div>
</template>
<script>
export default {
    data(){
        return {
            projectItem:{

            },
            formValidate:{

            },
            resourceList:[]
        }
    },
    methods:{
        getData(){
            return this.projectItem;
        },
        setData(data){
            this.projectItem=JSON.parse(JSON.stringify(data));
            
        },
        getStartTime(e){
            this.projectItem.startTime=e;
        },
         getEndTime(e){
            this.projectItem.endTime=e;
        },
    },
    mounted(){
      
    }

}
</script>